import { useStepper } from './StepperManager';

export const useStepperState = () => {
    const { state } = useStepper();

    return state;
};
